import { render } from "./ModalEditarFiltro.vue?vue&type=template&id=e678b5fe&scoped=true&ts=true"
import script from "./ModalEditarFiltro.vue?vue&type=script&lang=ts"
export * from "./ModalEditarFiltro.vue?vue&type=script&lang=ts"

import "./ModalEditarFiltro.vue?vue&type=style&index=0&id=e678b5fe&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e678b5fe"]])

export default __exports__